import mutations from './mutations';
import actions from './actions';
import getters from './getters';
export const getDefaultEstateState = () => {
    return {
        previewMode: false,
        current_step: 1,
        method: 'create',
        copyAddress: false,
        related_prop: {},
        payload: {
            street_address: '',
            street_number: '',
            apartment_number: '',
            zip: '',
            city: '',
            closest_station: '',
            sqm: null,
            rooms: 0,
            bedrooms: 0,
            biarea: '',
            lot_size: null,
            total_floor: null,
            description: '',
            available_from: '',
            available_until: '',
            lat: null,
            lon: null,
            year_built: null,
            advertised_rent: null,
            monthly_rent: null,
            props_ids: {},
            attachment_files: [],
            attachment_payload: [],
            attachment_update: [],
            file_ids: []
        },
        list: [],
        single: null
    };
};
export const state = getDefaultEstateState();
export const estate = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
